export default __webpack_public_path__ + "static/media/unity.a03c74b7.png";